import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class LoginRequest {
  getHeaders() {
    return {
      "Content-Type": "application/json",
    };
  }

  async login(payload) {
    try {
      const response = await axios.post(`${BASE_URL}/login`, payload, {
        headers: this.getHeaders(),
      });
      const data = response.data;
      return {
        success: true,
        message: "Login successful",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }

  async forgotPassword(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/email/resetpassword`,
        payload,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        success: true,
        message: "Password reset email sent",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.reason || "An error occurred",
        data: null,
      };
    }
  }

  async resetPassword(payload) {
    try {
      const response = await axios.post(`${BASE_URL}/resetpassword`, payload, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: "Password reset successful",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.reason || "An error occurred",
        data: null,
      };
    }
  }
}
const loginRequest = new LoginRequest();
export default loginRequest;